import DapDSFileInput from './file-input.component'

export * from './file-input.component'
export default DapDSFileInput

DapDSFileInput.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-file-input': DapDSFileInput
  }
}
